import { FC, useId } from 'react'
import { useTranslation } from 'react-i18next'
import { RadioChoice } from 'src/components/ui/choice/Choice'
import { ThemeChoice } from 'src/helpers/theme'
import { useTheme } from '@hooks/useTheme'

// The colour theme as the system's segmented control: light, dark or as the
// system (the default). The phone's profile menu and the desktop sidebar
// share it, next to the language.
const ThemeSegments: FC<{ className?: string; legendClassName?: string }> = ({
  className,
  legendClassName,
}) => {
  const { t } = useTranslation()
  const { choice, setChoice } = useTheme()
  // both menus are in the page at once: one radio group each
  const name = `theme-${useId()}`
  const options = [
    { value: 'light', label: t('theme.light') },
    { value: 'dark', label: t('theme.dark') },
    { value: 'system', label: t('theme.system') },
  ]
  return (
    <RadioChoice
      legend={t('theme.label')}
      name={name}
      variant="segmented"
      options={options}
      value={options.find((option) => option.value === choice)}
      onChange={(option) => setChoice(option.value as ThemeChoice)}
      className={className}
      legendClassName={legendClassName}
      itemClassName="!px-1.5 text-center"
    />
  )
}

export default ThemeSegments
